import "./i18n";
import { createRoot } from "react-dom/client";
import "./index.css";
import "remixicon/fonts/remixicon.css";
import App from "./App.tsx";

// [开发调试] 非微信环境支持通过 URL 参数设置 token
if (import.meta.env.DEV) {
  const params = new URLSearchParams(window.location.search);
  const devToken = params.get("dev_token");
  if (devToken && !/MicroMessenger/i.test(navigator.userAgent)) {
    import("./store/useUserStore").then(({ useUserStore }) => {
      useUserStore.getState().devSetToken(devToken);
    });
  }
}

createRoot(document.getElementById("root")!).render(<App />);
